import { PricingInfoList } from "../../pricing-info/PricingInfoList.js";
import { HeaderGroup } from "./HeaderGroup.js";
import { Stack, Subtitle2 } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/pharmacy-card/internal/CardContent.tsx
const CardContent = ({ title, description, pricing, value, additionalInfo, subtitle, footer, toggleFavorite, favorite = false }) => {
	const hasValidPriceList = !!pricing?.length;
	const altText = subtitle ? /* @__PURE__ */ jsx(Subtitle2, { children: subtitle }) : null;
	return /* @__PURE__ */ jsxs(Stack, {
		gap: "md",
		children: [
			/* @__PURE__ */ jsx(HeaderGroup, {
				title,
				toggleFavorite,
				description,
				value,
				favorite,
				additionalInfo
			}),
			(altText || hasValidPriceList) && /* @__PURE__ */ jsx(Stack, {
				gap: "sm",
				children: hasValidPriceList ? /* @__PURE__ */ jsx(PricingInfoList, { pricing }) : altText
			}),
			footer
		]
	});
};

//#endregion
export { CardContent };